import { useState, useEffect } from "react";
import { MainPageBase } from "../page-bases/MainPageBase";
import { NoItemContent } from "../page-bases/NoItemContent";
import { Box, Stack } from "@mui/material";
import { TRowItem } from "../../components/Table/TableRow";
import DamsTable from "../../components/Table/CollapsibleTable";
import { assetBatchDistributionApi } from "../../services/distribution/asset-distribution";
import useAppNavigation from "../../hooks/useAppNavigation";
import {
  IDistributionBatchRecord,
  IPagination,
  IQueryPerams,
} from "../../config/types";
import { usePagination } from "../../hooks/usePagination";
import { useMangeTableItems } from "../../hooks/useManageTableItems";
import { AssetDistributionLogsFilter } from "../../common-ui/page-filters/AssetDistributionLogsFilter";
import { BadgeLabel } from "../../components/Label";
import appRoutePath from "../../config/path";
import { formatDate } from "../../utils/common";

const AvailableDistributionForAssignementPage = () => {
  const [pageState, setPageState] = useState("main");
  const [dataset, setDataset] = useState<TRowItem[]>([]);
  const {
    selectedRowItems,
    toggleRow,
    toggleSelectAllRow,
    resetSelectedRowItems,
  } = useMangeTableItems(dataset, false);
  const {
    pagination,
    paginateToNextPage,
    paginateToPreviousPage,
    paginateToPageNumber,
    updatePaginationInitState,
  } = usePagination<IDistributionBatchRecord[]>(
    assetBatchDistributionApi.getReceivedBatchDistributions
  );

  const [querySet, setQuerySet] = useState<IQueryPerams>({ is_deleted: false });
  const populateDataSet = (
    data: IDistributionBatchRecord[],
    pagination?: IPagination
  ) => {
    const formatData=data.map((record)=>({
      ...record,
      from_location_domain:`${record.from_location_domain} (${record.from_location})`,
      to_location_domain:`${record.to_location_domain} (${record.to_location})`,
      created_at:formatDate(record.created_at),
    }))
    setDataset(formatData);
    updatePaginationInitState(pagination);
  };
  const fetchData = async () => {
    const result = await assetBatchDistributionApi.getReceivedBatchDistributions({
      is_deleted: false,
    });

    if (result?.data) {
      populateDataSet(result.data, result.pagination);
    }
  };
  useEffect(() => {
    fetchData();
    resetSelectedRowItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const navigate = useAppNavigation();

  function clearSearch() {
    setPageState("empty-db");
  }

  const BeginAssignmentButton = ({ item }: { item: TRowItem }) => {
    const handleTagAction = async () => {
      navigate({
        path: appRoutePath.ADD_NEW_ASSET_ASSIGNMENT_PAGE,
        params: { id: item.id },
      });
    };
    return (
      <Box>
        <BadgeLabel
          onClick={handleTagAction}
          title={"Proceed to Assign"}
          isLarge
          colorType="blue"
        />
      </Box>
    );
  };

  

  return (
    <MainPageBase
      pageState={pageState}
      title={"Distributions Ready for Assignment"}
      subtitle={"Review and assign assets to designated end users from the available distributions."}
      exportBtnOnClick={() => {
        alert("Exporting...");
      }}
      exportBtnText={"Export"}
    >
      <Box
        height={`100%`}
        display={"flex"}
        alignItems={pageState !== "main" ? "center" : ""}
        justifyContent={"center"}
      >
        {pageState !== "main" ? (
          <NoItemContent
            type={pageState}
            title={""}
            subtitle={""}
            clearSearchBtn={() => clearSearch()}
          />
        ) : (
          <Stack width={"100%"}>
            <AssetDistributionLogsFilter
              ftn={assetBatchDistributionApi.getReceivedBatchDistributions}
              updateDataSet={populateDataSet}
              updateQuerySet={setQuerySet}
            />
            <DamsTable
              tableTitle={"Available Asset Distributions"}
              tableSubtitle={
                "These distributions are ready to be assigned to end users. Review details and proceed with assignments."
              }
              numTableRecords="25"
              tableHeaders={columns}
              hasHeaderCheckBox={false}
              tableKeys={tkeys}
              data={dataset}
              maxRowCells={6}
              onTableItemSelect={toggleRow}
              toggleSelectAllRow={toggleSelectAllRow}
              selectedRowItems={selectedRowItems}
              hasPagination
              paginationState={pagination}
              onNextPage={paginateToNextPage(querySet, populateDataSet)}
              onPreviousPage={paginateToPreviousPage(querySet, populateDataSet)}
              setActivePage={paginateToPageNumber(populateDataSet, querySet)}
              extraRowComponent={BeginAssignmentButton}
            />
          </Stack>
        )}
      </Box>
    </MainPageBase>
  );
};

const tkeys = [
  "from_location_domain",
  "to_location_domain",
  "quantity",
  "created_at"
];

const columns = [
  "Distributor - Domain (Location)",
  "Recipent - Domain (Location)",
  "Number of Assets",
  "Created At",
];

export default AvailableDistributionForAssignementPage;
